import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import API from '../../../api/api'
import { useSnackbar } from '../../../helpers/hooks/useSnackbar'

interface GetEventStatisticsResponse {
  groupedStats: {
    ticketId: number
    ticketName: string
    revenue: number
    totalSignedUp: number
    totalCheckedIn: number
    residentsSignedUp: number
    residentsCheckedIn: number
    guestsSignedUp: number
    guestsCheckedIn: number
  }[]
  totalStats: {
    checkedIn: number
    revenue: number
    signedUp: number
  }
}

const emptyData = {
  groupedStats: [],
  totalStats: {
    checkedIn: 0,
    revenue: 0,
    signedUp: 0,
  },
}

export const useEventStatictics = ({ eventId }: { eventId: string }) => {
  const { t } = useTranslation(['attendees'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [data, setData] = useState<GetEventStatisticsResponse>(emptyData)

  const fetchData = async () => {
    try {
      setIsError(false)
      setIsLoading(true)

      const result = await API.getEventStatistics({ eventId })

      setData(result.data)
    } catch (error) {
      console.error(error)
      displaySnackbar(t('attendees:errors.loadStatistics'), true)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!eventId) {
      return
    }
    fetchData()
  }, [eventId])

  return { data, fetchData, isError, isLoading }
}
